var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-tips-wrapper"},[_c('iframe',{staticClass:"pdf-wrapper",attrs:{"src":"https://jydpro.jinr.com/uploadsFiles/jyd/static/risk.pdf","frameborder":"0"}}),_c('div',{staticClass:"btn",on:{"click":_vm.handleClick}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }